// extracted by mini-css-extract-plugin
export var activityContainer = "_lk-0";
export var typingIndicatorContainer = "_lk-1";
export var typingIndicatorDot = "_lk-2";
export var wave = "_lk-3";